(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => [...r.querySelectorAll(s)];

  const toggle = qs('[data-mobile-toggle]');
  const mobileNav = qs('[data-mobile-nav]');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const open = mobileNav.style.display === 'block';
      mobileNav.style.display = open ? 'none' : 'block';
      toggle.setAttribute('aria-expanded', String(!open));
    });
  }

  qsa('[data-qty]').forEach((wrap) => {
    const input = qs('input', wrap);
    qs('[data-minus]', wrap)?.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 1) - 1);
    });
    qs('[data-plus]', wrap)?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
    });
  });
})();
